import {LOCATION_CHANGE} from '../../components/common/LocationSync';
import { Reducer } from '@reduxjs/toolkit';

// Define state types
type RouterState = {
  location: any | null;
  action: string | null;
};

// Initial state
const initialState: RouterState = {
  location: null,
  action: null,
};

/**
 * Router reducer
 *
 * This is a replacement for the connectRouter reducer from connected-react-router
 */
const routerReducer: Reducer<RouterState> = (state = initialState, action: any) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        location: action.payload.location,
        action: 'PUSH', // Default action type, could be enhanced to track POP/REPLACE
      };
    default:
      return state;
  }
};

export default {
  reducer: routerReducer,
};